// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-people-of-interest) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.text-adjustment {
  margin-left: 10px;
}

.box-adjustment {
  margin-left: 10px;
  width: 99%;
}

.form-select {
  width: 101% !important;
}

.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
  padding-left: 10px;
}

.detail-form {
  height: 100%;
}

.remove-button {
  margin-left: 10px;
}

.required {
  color: red;
  font-size: 11px;
  padding-left: 2px;
}

label {
  font-size: 13px;
}

.names {
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.step-header {
  font-size: 17px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 20px;
  margin-left: 12px;
  color: var(--theme-main-color, #055C8D);
}

.form-control {
  width: 100% !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
